import React, { useEffect } from 'react'
import styled, { keyframes } from 'styled-components';
import AOS from 'aos'; 


const Document = styled.img`
    display: none;
    height: 70px;
    width: fit-content;
    background-color: #000;
    border-radius: 10px;
    &:hover{
        cursor: pointer;
        opacity: 0.8;
    }
`
const Description = styled.div`
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary + 99};
    margin-bottom: 10px;
    @media only screen and (max-width: 768px){
        font-size: 10px;
    }
`
const Span = styled.span`
overflow: hidden;
display: -webkit-box;
max-width: 100%;
-webkit-line-clamp: 4;
-webkit-box-orient: vertical;
text-overflow: ellipsis;
`
const ItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px; 
`

const Skills = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;

    @media only screen and (max-width: 768px){
        font-size: 12px;
        display: flex;
    }
`

const Skill = styled.div`
  display: flex; 
  flex-wrap: wrap; 
  font-size: 12px;
  color: ${({ theme }) => theme.text_primary};
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 5px;
  border-radius: 5px;
  whiteSpace: wrap;
  
  @media only screen and (max-width: 768px) {
    font-size: 10px;
    padding: 5px;
  }
`;

const spinInAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;


const spinOutAnimation = keyframes`
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const Image = styled.img`
  height: 50px;
  background-color: #000;
  border-radius: 10px;
  margin-top: 4px;
  transition: transform 0.2s; 

  @media only screen and (max-width: 768px) {
    height: 40px;
  }


  &:not(:hover) {
    animation: ${spinOutAnimation} 1s linear forwards; /* Apply the spin out animation */
  }

`;
const Card = styled.div`
    width: 530px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
    padding: 12px 16px ;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &:hover{
        box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
        transform: translateY(-5px);
        background: rgba(133, 76, 230, 0.05);

    }
    @media only screen and (max-width: 768px){
        padding: 10px;
        gap: 8px;
        width: 330px;
        border: 0.1px solid #854CE6;
        background: rgba(133, 76, 230, 0.05);

    }

    &:hover ${Document}{
        display: flex;
    }

    &:hover ${Span}{
        overflow: visible;
        -webkit-line-clamp: unset;

    }

    &:hover {
       
       transform: scale(1.05) translateY(-5px);
       box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);  
       border: 0.1px solid #854CE6;
   }
    box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;

    &:hover{
        ${'' /* ${Description}{
            color: white
        } */}
        ${Skill}{
            color: ${({ theme }) => theme.text_primary};
        }
        ${'' /* ${Image}{
            transform: scale(1.2) rotate(360deg); 
            animation: ${spinInAnimation} 1s linear forwards; 
        } */}
    }
    
`

const Top = styled.div`
    width: 100%;
    display: flex;
    gap: 12px
`
const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column; 
    
`
const Role = styled.div`
    font-size: 24px;
    font-weight: 600;
    color:  ${({ theme }) => theme.primary};
    @media only screen and (max-width: 768px){
        font-size: 14px;
    }
`

const Company = styled.div`
    font-size: 16px;
    font-weight: 500;
    color:  ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
   
`
const Date = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary + 80};
    @media only screen and (max-width: 768px){
        font-size: 10px;
    }
`
const ExperienceCard = ({ experience, index }) => {
    useEffect(() => {
        AOS.init({
          duration: 1000,
          offset: 200,
        });
    
        AOS.refresh();
    
        return () => {
          AOS.refresh();
        };
      }, []);
    return (
        <Card data-aos= "fade-left">
            <Top>
                <Image src={experience.img} />
                <Body>
                    <Role>{experience.role}</Role>
                    <Company>{experience.company}</Company>
                    <Date>{experience.date}</Date>
                </Body>
            </Top>
            <Description>
                {/* {experience?.desc &&
                    <Span>{experience?.desc}</Span>

                } */}
                {experience?.skills &&
                    <>
                        <br />
                        <Skills>
                           {/* <b>Skills:</b>  */}
                            <ItemWrapper>
                                {experience?.skills?.map((skill, index) => (
                                    <Skill>{skill}</Skill>
                                ))}
                            </ItemWrapper>
                        </Skills>
                        
                    </>
                }
            </Description>
           
        </Card>
    )
}

export default ExperienceCard